"use strict";
/**
 * Shared Enums
 *
 * Consolidated enum definitions for string literal unions
 * used across multiple packages in the Free Pattern Warehouse.
 *
 * These enums replace inline string literal unions to provide
 * compile-time enforcement and IDE autocomplete.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagContentType = exports.ModerationQueueCategory = exports.ModerationItemType = exports.ProjectStatus = exports.PublishStatus = exports.MaterialScanResult = exports.PublishScanResult = exports.DatabaseScanResult = exports.ModerationResolution = exports.ModerationStatus = void 0;
var moderation_status_1 = require("./moderation-status");
Object.defineProperty(exports, "ModerationStatus", { enumerable: true, get: function () { return moderation_status_1.ModerationStatus; } });
Object.defineProperty(exports, "ModerationResolution", { enumerable: true, get: function () { return moderation_status_1.ModerationResolution; } });
var scan_result_1 = require("./scan-result");
Object.defineProperty(exports, "DatabaseScanResult", { enumerable: true, get: function () { return scan_result_1.DatabaseScanResult; } });
Object.defineProperty(exports, "PublishScanResult", { enumerable: true, get: function () { return scan_result_1.PublishScanResult; } });
Object.defineProperty(exports, "MaterialScanResult", { enumerable: true, get: function () { return scan_result_1.MaterialScanResult; } });
var publish_status_1 = require("./publish-status");
Object.defineProperty(exports, "PublishStatus", { enumerable: true, get: function () { return publish_status_1.PublishStatus; } });
var project_status_1 = require("./project-status");
Object.defineProperty(exports, "ProjectStatus", { enumerable: true, get: function () { return project_status_1.ProjectStatus; } });
var entity_type_1 = require("./entity-type");
Object.defineProperty(exports, "ModerationItemType", { enumerable: true, get: function () { return entity_type_1.ModerationItemType; } });
Object.defineProperty(exports, "ModerationQueueCategory", { enumerable: true, get: function () { return entity_type_1.ModerationQueueCategory; } });
Object.defineProperty(exports, "FlagContentType", { enumerable: true, get: function () { return entity_type_1.FlagContentType; } });
